/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0wOv4Q18ZR%7Bcursor%3Adefault%7D");
import { type CSSProperties, type ReactNode, forwardRef } from 'react';
import { DefaultRoleContext, useDefaultRole } from './internal/default-role-context';
import { TooltipShortcut } from './tooltip-shortcut';
import { type PositionType } from './types';
export interface TooltipPrimitiveProps {
  // eslint-disable-next-line @repo/internal/react/boolean-prop-naming-convention
  truncate?: boolean;
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
  testId?: string;
  placement: PositionType;
  ref?: React.Ref<HTMLDivElement>;
  onMouseOver?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseOut?: (e: React.MouseEvent<HTMLDivElement>) => void;
  id?: string;
  shortcut?: string[];
  role?: React.AriaRole;
}
const primitiveStyles = null;

/**
 * The lower level component for rendering a tooltip.
 */
const TooltipPrimitive: React.ForwardRefExoticComponent<React.PropsWithoutRef<TooltipPrimitiveProps> & React.RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, TooltipPrimitiveProps>(function TooltipPrimitive({
  style,
  className,
  children,
  placement,
  testId,
  onMouseOut,
  onMouseOver,
  id,
  shortcut,
  role
}, ref) {
  const defaultRole = useDefaultRole();
  return <div ref={ref} style={style} data-testid={testId ? `${testId}--wrapper` : undefined}>
			{/* Re: non-interactive element interactions: Because we are creating a tooltip, we *need* these mouse handlers. */}
			<div role={role ?? defaultRole ?? 'tooltip'}
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className={ax(["_0wOv4Q18ZR", className])}
    // Because the tooltip should not be focusable, there is no reason to have key events.
    /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut={onMouseOut}
    /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver={onMouseOver} data-placement={placement} data-testid={testId} id={id}>
				{/* Reset the default so a primitive inside tooltip content keeps role="tooltip". */}
				<DefaultRoleContext.Provider value={undefined}>{children}</DefaultRoleContext.Provider>
				{shortcut && <TooltipShortcut shortcut={shortcut} />}
			</div>
		</div>;
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
export default TooltipPrimitive;